import { useState } from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';

import { Props } from './tooltip.types';

export const Tooltip = ({
  button,
  popoverContent,
  ariaLabel,
  buttonStyles,
  popoverClasses = 'relative',
  buttonClasses = '',
  popoverStyles,
  buttonTestId = '',
  anchorProps = { to: 'bottom start', gap: 16 },
  activateWithHover = false,
  onButtonClick,
}: Props & { activateWithHover?: boolean }) => {
  const [hoverOpen, setHoverOpen] = useState(false);

  return (
    <Popover
      className={popoverClasses}
      style={popoverStyles}
      onMouseEnter={activateWithHover ? () => setHoverOpen(true) : undefined}
      onMouseLeave={activateWithHover ? () => setHoverOpen(false) : undefined}>
      {({ open }) => (
        <>
          <PopoverButton
            aria-label={ariaLabel}
            style={buttonStyles}
            className={buttonClasses}
            data-testid={buttonTestId}
            onClick={onButtonClick}>
            {button}
          </PopoverButton>
          <Transition
            show={activateWithHover ? hoverOpen : open}
            enter='transition duration-200 ease-out'
            enterFrom='scale-95 opacity-0'
            enterTo='scale-100 opacity-100'
            leave=' transition duration-175 ease-out'
            leaveFrom='scale-100 opacity-100'
            leaveTo='scale-95 opacity-0'>
            <PopoverPanel anchor={anchorProps} className='z-50 flex origin-top flex-col transition'>
              {popoverContent}
            </PopoverPanel>
          </Transition>
        </>
      )}
    </Popover>
  );
};
